<template>
    <div class="ui-content dashboard user-section user-height">
        <v-card class="mx-auto normal-card autohg">
            <div class="data-table-section" ref="infoBox">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                            :onSortChange="onSortChange"
                        />
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.name }}</td>
                                <td class="text-alignment">{{ item.email }}</td>
                                <td class="text-center">
                                    {{ getCenter(item.subjects) }}
                                </td>
                                <td class="text-alignment" v-model="showToolTip" :disabled="!buttonHovering"> <v-tooltip bottom content-class="cust-new-tooltip-top open-top">
										<template v-slot:activator="{ on }">
                                            <v-hover v-model="buttonHovering">
                                                <span
											   v-on="on"
											   depressed
												:class="{
												'text-transform-none': true,
												'btn-center': true,
												'btn-default': true,
											}"
											
											>{{compareCenters(item.center).length< 10 ? compareCenters(item.center):compareCenters(item.center).substring(0,10) + '...'}}</span
											>

                                            </v-hover>
											
										</template>
										<span>{{compareCenters(item.center)}} </span>
										</v-tooltip>
								</td>
                                 <td class="text-alignment width-batch-field" v-model="showToolTip" :disabled="!buttonHovering"> <v-tooltip bottom content-class="cust-new-tooltip-top open-top">
										<template v-slot:activator="{ on }">
                                            <v-hover v-model="buttonHovering">
                                                <span
											    v-on="on"
											    depressed
												:class="{
												'text-transform-none': true,
												'btn-center': true,
												'btn-default': true,
											}"
											
											>{{compareBatches(item.batch).length< 21 ? compareBatches(item.batch):compareBatches(item.batch).substring(0,21) + '...'}}</span
											>

                                            </v-hover>
											
										</template>
										<span>{{compareBatches(item.batch)}} </span>
										</v-tooltip>
								</td>

                                 
                                <td>
                                    <div class="switch-cust">
                                        <v-switch
                                            v-model="item.active"
                                            inset
                                        ></v-switch>
                                    </div>
                                </td>
                                <td class="blank-80 action-icons manage-edit-icon">
                                    <v-tooltip
                                        v-if="active === 1"
                                        left
                                        content-class="cust-tooltip"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                class="pencil-icon"
                                                v-on="on"
                                                @click="editTeacherDialog(item)"
                                                >mdi-pencil</v-icon
                                            >
                                        </template>
                                        <span>Edit Name / Email / Batches</span>
                                    </v-tooltip>
                                    <!-- this worked   -->
                                    <v-tooltip
                                        v-else
                                        left
                                        content-class="cust-tooltip"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                class="delete-icon"
                                                v-on="on"
                                                @click="onDelete(item)"
                                                >mdi-delete</v-icon
                                            >
                                        </template>
                                        <span>Delete Teacher</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-left">
                                    <div @click="resetPassword(item)">
                                        <v-icon
                                            title="Reset Password"
                                            class="cp3-reset-pass reset-student-password"
                                            >mdi-lock-reset</v-icon
                                        >
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <AlertBox
                    width="450px"
                    :onClose="onClose"
                    :component="cComponent"
                    :status="status"
                    :data="selctedUserForEdit"
                />
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left">
                <v-btn
                    @click="toggleUserStatus"
                    class="right-btn cust-btn"
                    color="primary"
                    >{{
                        active === 1
                            ? "Deactivated Teachers"
                            : "Active Teachers"
                    }}</v-btn
                >
            </div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "ManageUsersDEO",
    props: ["updateRouteDetails", "search"],
    data() {
        return {
            loading: false,
            items: [],
            oldData: [],
            orderBy: {
                field: "name",
                order: "ASC",
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            active: 1,
            centers: [],
            selectedCenterId: [],
            status: false,
            selctedUserForEdit: {},
            classes: [],
            subjects: [],
            selectedClass: {},
            subject: [],
            isLoadingFirstTime: true,
            selectedSubject: [],
            cComponent: "",
            isTeacher: true,
            batches: [],
            buttonHovering: false,
            showToolTip: false
        };
    },
    methods: {
        ...mapActions({
            getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
            setUserActiveStatus: "userStore/setUserActiveStatus",
            getCenters: "centerAndBatchStore/getCenters",
            deleteUser: "userStore/deleteUser",
            getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
            getCentersByUser: "centerAndBatchStore/getCentersByUser",
            getBatches: "centerAndBatchStore/getBatches",
        }),
        toggleUserStatus() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.active = this.active === 1 ? 0 : 1;
            this.updateRouteDetails({
                type: "activateStatus",
                data: { active: this.active, page: 1 },
            });
            this.requesGetSelfSignedUpUsers();
        },
        requesGetSelfSignedUpUsers() {
            let reqData = {
                role_id: this.roleIds.TR,
                is_approved: 1,
                active: this.active,
                orderBy: {
                    field: this.orderBy.field,
                    order: this.orderBy.order,
                },
                pagination: { page: this.currentPage, pageSize: this.pageSize },
                searchQuery: this.search,
            };
            if (this.selectedClass) {
                reqData.class = this.selectedClass
                    ? this.selectedClass.title
                    : "";
            }
            if (this.selectedSubject) {
                reqData.subject =
                    this.selectedSubject.length > 0 ? this.selectedSubject : "";
            }
            this.$root.showLoader = true;
            this.getSelfSignedUpUsers(reqData)
                .then((response) => {
                    this.items = response.list.map((u) => {
                        u.checked = false;
                        u.canEdit = false;
                        u.center = u.center;
                        return u;
                    });
                    this.setOldData(this.items);
                    this.totalPages = response.pagination.pageCount;
                    this.$root.showLoader = false;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onSortChange() {
            this.requesGetSelfSignedUpUsers();
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requesGetSelfSignedUpUsers();
        },
        requestUpdateUserActiveStatus(user_ids, status, index) {
            let reqData = {
                user_ids: user_ids,
                active: status,
            };
            this.$root.showLoader = true;
            this.setUserActiveStatus(reqData)
                .then((response) => {
                    this.$root.showLoader = false;
                    if (index || index === 0) {
                        this.items.splice(index, 1);
                    } else {
                        this.items = [];
                    }
                    this.setOldData(this.items);
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        setOldData(data) {
            this.oldData = _.cloneDeep(data);
        },
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd) {
                this.searchText = crd.searchText ? crd.searchText : null;
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
                this.active = crd.tabDetails[crd.selectedTab].showActivated;
            }
            this.requesGetSelfSignedUpUsers();
        },
        getCenter(selectedSubject) {
            let subject = [];
            if (selectedSubject && selectedSubject.length) {
                this.subject.map((m) => {
                    if (selectedSubject.includes(m.id)) {
                        subject.push(m.title);
                    }
                });
            }

            return subject.join(", ");
        },
        requestGetCenters() {
            this.getCenters()
                .then((response) => {
                    this.loading = false;
                    this.centers = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                    this.centerList = this.centers;
                })
                .catch((err) => {
                    this.loading = false;
                });
        },

        editTeacherDialog(user) {
            this.cComponent =
                "components/coordinator/users/EditUsers/EditTeacher";
            this.selctedUserForEdit = user;
            this.status = true;
        },
        resetPassword(item) {
            this.cComponent = "components/coordinator/ResetStudentPassword";
            this.status = true;
            item.persistent = false;
            this.selctedUserForEdit = item;
        },
        onClose(data) {
            this.status = data.status;
            if (data.reload) {
                this.requesGetSelfSignedUpUsers();
            }
            if (data.is_delete) {
                this.onDeleteTeacher(
                    this.selctedUserForEdit,
                );
            }
        },
        onDelete(item) {
            this.cComponent =
                "components/coordinator/users/ManageUsers/ConfirmationDialog";
            this.selctedUserForEdit = item;
            this.selctedUserForEdit.isTeacher = true;
            this.status = true;
        },
        onDeleteTeacher(user) {
                if (user) {
                    const reqData = {
                        user_id: [user.id],
                    };
                    this.deleteUser(reqData)
                        .then((response) => {
                            this.$toasted.success(
                                `Teacher Deleted Successfully`,
                                {
                                    icon: "check_circle",
                                }
                            );
                            this.requesGetSelfSignedUpUsers();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
        },
        requestGetCenters() {
        this.$root.showLoader = true;
        this.centers = [];
        this.centersList = [];
        this.getCentersByUser()
        .then((response) => {
          this.centers = response;
          this.$root.showLoader = false;
          let centerIds = [];
          this.centersList = response.map((x) => {
            centerIds.push(x.id);
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
         
          this.onCenterSelect(centerIds);
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    compareCenters(centers) {
      let userCenters = [];
      if (centers && centers.length) {
        this.centers.map((m) => {
          if (centers.includes(m.id)) {
            userCenters.push(m.name);
          }
        });
       
      }
      return userCenters.join(", ");
    },
     onCenterSelect(centerIds) {
      if (centerIds && centerIds.length) {
        this.$root.showLoader = true;
        //this.batches = [];
        this.getBatches({ center_id: centerIds })
          .then((response) => {
        this.$root.showLoader = false;

            if (response && response.list && response.list.length) {
              this.batches = response.list;
             
            } 
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } 
    },
    compareBatches(batches) {
      let userBatches = [];
      if (batches && batches.length && this.batches.length) {
        this.batches.map((m) => {
          if (batches.includes(m.id)) {
            userBatches.push(m.name);
          }
        });
      
      }
      return userBatches.join(", ");
    },
        onHeaderAction(e) {
            if (e.header && e.header.type === "check") {
                if (e.data) {
                    this.items = this.items.map((u) => {
                        u.checked = e.data.checked;
                        return u;
                    });
                }
            } else if (
                e.header &&
                e.header.type === "multidropdown" &&
                e.header.value === "subject"
            ) {
                this.selectedSubject = e.data.selectedItems;
            } else if (
                e.headers &&
                e.headers.type === "dropdown" &&
                e.headers.value === "class_code"
            ) {
                this.selectedClass = e.data.selectedItem;
            } else if (e.header && e.header.type === "button") {
                if (this.items && this.items.length) {
                    let allUsers = this.items.map((u) => {
                        return u.id;
                    });
                    this.requestUpdateUserActiveStatus(
                        allUsers,
                        this.active === 1 ? false : true
                    );
                }
            }
        },
        getSubjects() {
            let reqData = {
                level: 2,
            };
            this.subjects = [];
            this.selectedSubject = null;
            this.$root.showLoader = true;
            this.getDataTreeWithLevel(reqData)
                .then((response) => {
                    this.$root.showLoader = false;
                    if (this.isLoadingFirstTime) {
                        this.subject = response;
                    } else {
                        this.subjects = response.map((x) => {
                            let c = {};
                            c.text = x.title;
                            c.value = x.id;
                            return c;
                        });
                    }
                    this.isLoadingFirstTime = false;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
    },
    mounted() {
        this.getSubjects();
        this.requestGetCenters();
        this.defaultData();
    },
    computed: {
        headers() {
            return [
                { text: "Name", value: "name" },
                { text: "Email ID", value: "email",class: "text-center" , hideSort: true },
                { text: "Subject", value: "subjects", class: "text-center" },
                { text: "Center", value: "center", class: "text-center width-200" },
                { text: "Batch", value: "batch", class: "text-center width-batch-field " },
                { text: "", value: "", type: "blank", class: "blank-80" },
                { text: "", value: "", type: "blank", class: "blank-80" },
            ];
        },
    },
    watch: {
        selectedSubject(val) {
            // if (!this.isLoadingFirstTime) this.resetPage();
            // this.updateRouteDetails({ type: 'batchIds', data: { batchIds: val } });
            if (val) {
                this.requesGetSelfSignedUpUsers();
            }
        },
        items: {
            deep: true,
            handler(after, before) {
                let changedItem, index;
                after.map((p, idx) => {
                    if (p["active"] !== this.oldData[idx]["active"]) {
                        changedItem = p;
                        index = idx;
                    }
                });
                this.setOldData(after);

                if (changedItem) {
                    this.requestUpdateUserActiveStatus(
                        [changedItem.id],
                        changedItem.active ? true : false,
                        index
                    );
                }
            },
        },
        search() {
            this.requesGetSelfSignedUpUsers();
        },
         buttonHovering (val) {
         
         this.showToolTip = val;
        },
    },
};
</script>